import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../../components/ui/table";
import { formatTripDateRangeToDateAndMonth } from "../../../utils/DateUtils";
import { Link } from "react-router-dom";

export const LeadsView = ({ leads }) => {
  const [tripNameFilter, setTripNameFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [filteredLeads, setFilteredLeads] = useState([]);

  useEffect(() => {
    const leadsList = leads
      .filter((lead) => {
        const predicate =
          !tripNameFilter ||
          lead.trip.tripName
            .toLowerCase()
            .includes(tripNameFilter.toLowerCase());
        return predicate;
      })
      .filter((lead) => {
        const predicate =
          !statusFilter ||
          statusFilter === "All Status" ||
          lead.leadStatus === statusFilter;
        return predicate;
      });
    setFilteredLeads(leadsList);
  }, [leads, tripNameFilter, statusFilter]);

  return (
    <div className="w-full h-full p-4">
      <div className="flex flex-col">
        <h1 className="text-2xl font-semibold mb-4">Leads</h1>
        <div className="flex space-x-4 mb-4">
          {/* Trip Name Filter */}
          <input
            type="text"
            placeholder="Search Trip Name"
            value={tripNameFilter}
            onChange={(e) => setTripNameFilter(e.target.value)}
            className="p-2 border border-gray-300 rounded-md"
          />
          {/* Status Filter */}
          <select
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
            className="p-2 border border-gray-300 rounded-md"
          >
            <option value="">All Status</option>
            {/* Add options for each possible status */}
            <option value="new">new</option>
            <option value="converted">converted</option>
            <option value="lost">lost</option>
          </select>
        </div>
        <div className="overflow-x-auto">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Name</TableHead>
                <TableHead>Email</TableHead>
                <TableHead>Phone</TableHead>
                <TableHead>Trip</TableHead>
                <TableHead>Selected Date</TableHead>
                <TableHead>Created Date</TableHead>
                <TableHead>Status</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {filteredLeads.map((lead) => (
                <TableRow key={lead._id}>
                  <TableCell>{lead.name}</TableCell>
                  <TableCell>{lead.email}</TableCell>
                  <TableCell>{lead.phone}</TableCell>
                  <TableCell>
                    <Link
                      className="text-blue-500 hover:underline cursor-pointer"
                      to={`/trip/${lead.trip._id}`}
                    >
                      {lead.trip.tripName}
                    </Link>
                  </TableCell>
                  <TableCell>
                    {formatTripDateRangeToDateAndMonth(lead.selectedDate)}
                  </TableCell>
                  <TableCell>{lead.createdAt.toLocaleDateString()}</TableCell>
                  <TableCell>{lead.leadStatus}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </div>
    </div>
  );
};
